<template>

<footer class="footer">
  <div class="footer-container">
    <!-- Kontaktinformation -->
    <div class="footer-contact">
      <h3>Kontakt</h3>
      <p> 070-736 88 99</p>
      <p>info@theloungebar.se</p>
      <p>Sveavägen 45, Stockholm</p>
    </div>

    <!-- Öppettider -->
    <div class="footer-hours">
      <h3>Öppettider</h3>
      <ul>
        <li>Måndag - Torsdag: 14:00 - 01:00</li>
        <li>Fredag: 12:00 - 01:00</li>
        <li>Lördag: 11:00 - 01:00</li>
        <li>Söndag: 12:00 - 01:00</li>
      </ul>
    </div>

    <!-- Sociala medier -->
    <div class="footer-social">
      <h3>Följ oss</h3>
      <div class="social-icons">
        <a href="https://www.facebook.com/profile.php?id=61571432892822"><img src="/assets/fb-icon.svg"></a>
        <a href="https://www.instagram.com/theloungebar.se/"><img src="/assets/insta-icon.svg"></a>
      </div>
    </div>
  </div>

  <!-- Copyright -->
  <div class="footer-bottom">
    <p> 
      © 2025 The Lounge Bar - Alla rättigheter reserverade.<br>
      Webbdesign av Romina från PR Agenturen Sverige AB
    </p>
  </div>
</footer>

</template>

<style>
/* Footer bakgrund och layout */
.footer {
  background-color: #1C2A1F; /* Olivgrön bakgrund */
  color: #f5f5f5; /* Ljus text */
  padding: 2rem 1rem;
  text-align: center;
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  gap: 2rem;
}

/* Sektioner i footern */
.footer-contact, .footer-hours, .footer-social {
  flex: 1;
  min-width: 200px;
}

.footer h3 {
  font-size: 1.5rem;
  color: #937d51; /* Ljusgul färg för rubriker */
  margin-bottom: 1rem;
}

.footer p, .footer ul, .footer a {
  font-size: 1rem;
  line-height: 1.6;
  color: #f5f5f5;
}

/* Öppettider lista */
.footer-hours ul {
  list-style: none;
  padding: 0;
}

.footer-hours li {
  margin-bottom: 0.5rem;
}

/* Sociala medier */
.footer-social .social-icons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.footer-social a {
  color: #f5f5f5;
  font-size: 1.5rem;
  transition: color 0.3s ease;
}

.footer-social a:hover {
  color: #f0e68c; /* Ljusgul hover-effekt */
}

/* Copyright */
.footer-bottom {
  margin-top: 2rem;
  font-size: 0.9rem;
  color: #d3d3d3; /* Ljusrå text för copyright */
  border-top: 1px solid #f5f5f5;
  padding-top: 1rem;
}


</style>